import useEntities from 'hooks/useEntities';
import HmsEntityTableController from 'components/HmsEntityTableController';

const SchedulerConfigs = () => {
  const entities = useEntities();
  const filterGroups = null;
  // HmsEntityTableController uses fixedX: columns without width default to 100,
  // and the table stretches to 100% viewport (antd minWidth:100%), so widths are
  // proportional. Give name a large share so other columns stay tight.
  const showColumns = [
    { column: 'createdAt', defaultSortOrder: 'descend', width: 168 },
    { column: 'CompetitionSeason', width: 190, ellipsis: true },
    { column: 'Competition', visible: false },
    { column: 'Season', visible: false },
    { column: 'name', width: 800 },
    { column: 'GroupCount', width: 80 },
    { column: 'TeamCount', width: 75 },
    { column: 'VenueCount', width: 80 },
    { column: 'SchedulerSimulationCount', width: 105 },
    { column: 'GeneratedGameCount', width: 90 },
    { column: 'algorithm', width: 125 },
    {
      column: 'createdBy',
      width: 150,
      ellipsis: true,
      onCell: () => ({ style: { maxWidth: 150, width: 150 } }),
      onHeaderCell: () => ({ style: { maxWidth: 150, width: 150 } }),
    },
  ];

  return (
    <HmsEntityTableController
      entity={entities.SchedulerConfig}
      filterGroups={filterGroups}
      showColumns={showColumns}
    />
  )
}

export default SchedulerConfigs
